import React from "react"

import "./filter-multi-check-img.scss"

const FilterMultiCheckImg = props => {
  const {
    currentSubcategory,
    title,
    options,
    handleChangeFilter,
    numfilter,
    activeFilters,
  } = props
  const [curtain, setCurtain] = React.useState(false)
  
  const itemsFilterFlujo = (label) => {
    
    switch (label) {
      case "Liviano":
        return <span className={`icon-flujo flujometro-regular-icon`} />
      case "Normal":
        return <span className={`icon-flujo flujometro-abundante-icon`} />
      case "Fuerte":
        return <span className={`icon-flujo flujometro-super-abundante-icon`} />
      case "Multifluido":
        return <span className={`icon-flujo flujometro-multifluido-icon`} />
      default:
        return <span className={`icon-flujo flujometro-regular-icon`} />
    }
  }

  const changeLabelByCountry = (label, title) => {    
    switch (label) {
      case "Liviano":
        return "Regular"
      case "Normal":
        return "Abundante"
      case "Fuerte":
          return "Súper Abundante"
      default:
        return label
    }
  }

  const itemsFilterAlas = numItems => {
    switch (numItems) {
      case 0:
        return <span className="icon-product"></span>
      case 1:
        return <span className="icon2-sin-alas"></span>

      default:
        break
    }
  }

  return (
    <>
      {process.env.LOCALE === "es-DO" &&
      currentSubcategory === "protectores-diarios" &&
      title === "Característica" ? null : (
        <div className="f-FilterMultiCheckImg">
          <span className="f-Filter-title">{title}</span>
          <div className="f-FilterMultiCheckImg-options">
            {options.map((label, index) => {
              return (
                <div
                  key={index}
                  className={
                    activeFilters.find(x => x.id === numfilter + index)
                      ? activeFilters.find(x => x.id === numfilter + index)
                          .value
                        ? "f-FilterMultiCheckImg-options-active"
                        : ""
                      : ""
                  }
                  onClick={() => {
                    if (curtain) {
                      setCurtain(false)
                    } else {
                      setCurtain(true)
                    }
                    handleChangeFilter(label, label, numfilter + index, title)
                  }}
                >
                  <div className="f-FilterMultiCheckImg-options-icon">
                    {title === "Flujo"
                      ? itemsFilterFlujo(label)
                      : itemsFilterAlas(index)}
                  </div>
                  <label>{changeLabelByCountry(label, title)}</label>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </>
  )
}

export default FilterMultiCheckImg
